import React from "react";
import {Route, Redirect, Switch, useLocation} from "react-router-dom";
import URLS from "../../config/navigation";
 
import TopBar from "../../components/Profile/TopBar";
import StripBox from "../../components/Profile/StripeVerify/index"
import UserProfile from "../../components/Profile/UserProfile";
import PaymentsTable from "../../components/Profile/PaymentsTable";
import SettingsContainer from './SettingsContainer'
import PreviewUserUrl from "../../components/Profile/PreviewUserUrl";
import SettingsMobileContainer from "../../components/Common/SettingsMobileContainer";

const Profile = () => {
  const location = useLocation();
  return (
    <div className={"COLUMN_FLEX_CENTER profile-container"}>
      <StripBox />
      <TopBar />
      { location.pathname === URLS.PROFILE.DATA && <PreviewUserUrl /> }
      <div className={"center-container"}>
        <Switch>
          <Route path={URLS.PROFILE.DATA} component={UserProfile} />
          <Route path={URLS.PROFILE.PAYMENTS} component={PaymentsTable} />
          <Route path={URLS.PROFILE.SETTINGS} component={SettingsContainer} />
          <Route component={() => <Redirect to={URLS.PROFILE.DATA} />} />
        </Switch>
      </div>
    </div>
  );
};

export default Profile;
